import { render, staticRenderFns } from "./EpPromotionSummary.vue?vue&type=template&id=2bf61394&"
import script from "./EpPromotionSummary.vue?vue&type=script&lang=js&"
export * from "./EpPromotionSummary.vue?vue&type=script&lang=js&"
import style0 from "./EpPromotionSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports